import { collapseAccordion } from '../../3-components/Accordion/AccordionHelpers';
import Accordion from '../../3-components/Accordion/AccordionObj';

interface MobileNavProps {
    el: HTMLDivElement;
}

const ITEM_CLASS = 'mobile-nav-item';
const TRIGGER_CLASS = 'mobile-nav-trigger';
const COLLAPSIBLE_CLASS = 'mobile-nav-item-content-wrapper';

const MobileNav = ({ el }: MobileNavProps): void => {
    const props = {
        collapseOthers: true,
        itemClass: ITEM_CLASS,
        triggerClass: TRIGGER_CLASS,
        collapsibleClass: COLLAPSIBLE_CLASS,
    };

    Accordion({ el, props });
};

export const closeAllMenuMobileNav = ({ el }: MobileNavProps): void => {
    const itemEls = el.querySelectorAll(`.${ITEM_CLASS}`);
    itemEls.forEach(itemEl => {
        if (itemEl.classList.contains('is-open')) {
            const triggerEl = itemEl.querySelector(`.${TRIGGER_CLASS}`) as HTMLButtonElement | null;
            const collapsibleEl = itemEl.querySelector(`.${COLLAPSIBLE_CLASS}`) as HTMLDivElement | null;

            if (!triggerEl || !collapsibleEl) {
                return;
            }

            collapseAccordion(collapsibleEl, () => {
                itemEl.classList.remove('is-open');
                el.setAttribute('aria-expanded', 'false');
                triggerEl?.setAttribute('aria-expanded', 'false');
            });
        }
    });
};

export default MobileNav;
